import { createSlice } from '@reduxjs/toolkit';
import { UserSliceState } from './userSliceState';

const initialState: UserSliceState = {
  userId: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId(state, action) {
      state.userId = action.payload;
    },
  },
});

export const { setUserId } = userSlice.actions;

export default userSlice.reducer;
